import es from 'vuejs-datepicker/dist/locale/translations/es';

const EstadosCiviles = [
    {id: 1, label:'Soltera (o)'} ,
    {id: 2, label:'Casada (o)'} ,
    {id: 3, label:'Divorciada (o)'} ,
    {id: 4, label:'Union Libre'} ,
    {id: 5, label:'Viuda (o)'} ,
    {id: 6, label:'Concubinato'} ,
];

const Genero = [
    {id: 1, label:'Femenino'} ,
    {id: 2, label:'Masculino'} ,
];

const Equipo = [
    {id: 1, label:'Vehículo'} ,
    {id: 2, label:'Teléfono'} ,
    {id: 3, label:'Linea Telefonica'} ,
];

const calendarSettings = {
    Style: 'form-control',
    Formato: 'yyyy-MM-dd',
    Idioma: es,
    DisabledDates: {
        to: new Date(Date.now() - 8640000)
    }
}

const CalendarioMeses = [
    {clave: 1, label: "Enero"},
    {clave: 2, label: "Febrero"},
    {clave: 3, label: "Marzo"},
    {clave: 4, label: "Abril"},
    {clave: 5, label: "Mayo"},
    {clave: 6, label: "Junio"},
    {clave: 7, label: "Julio"},
    {clave: 8, label: "Agosto"},
    {clave: 9, label: "Septiembre"},
    {clave: 10, label: "Octubre"},
    {clave: 11, label: "Noviembre"},
    {clave: 12, label: "Diciembre"},
];


export default {
    EstadosCiviles,
    Genero,
    Equipo,
    calendarSettings,
    CalendarioMeses,
};
